import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { UserTypesRelationshipService } from 'src/app/services/user-types-relationship.service';
import { ToastrService } from 'ngx-toastr';
import { ProviderProviderAssociationService } from '../provider-provider-association.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-provider-provider-association',
  templateUrl: './provider-provider-association.component.html',
  styleUrls: ['./provider-provider-association.component.css']
})
export class ProviderProviderAssociationComponent implements OnInit {
  public response: any;
  public relationData: any;
  public dataSource: any;
  public providers: any = [];
  //associated_providers: any = [];
  providersName: any = [];
  selectedProviders: any = [];
  providerTranscriber: Boolean = true;
  providerProvider: Boolean = true;
  providerDropdownSettings: any = {};
  assigned: Boolean = false;
  company_id: any;
  public counter = 0;
  public dropDProviders: any = [];
  displayedColumns2: string[] = ['provider_name', 'asso_provider_name'];
  constructor(
    public services: ProviderProviderAssociationService,
    private toastr: ToastrService,
    private route: ActivatedRoute
  ) {
    this.providerDropdownSettings = {
      singleSelection: false,
      idField: '_id',
      textField: 'full_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: true,
      enableCheckAll: true,
    };
  }

  async ngOnInit() {
    if (window.location.pathname.includes('company')) {
      this.company_id = this.route.parent.snapshot.params.id
    }
    else {
      this.company_id = '';
    }
    await this.loadDataForProvider();
  }
  getProvidersNameDropDown(element) {
    let array = [];
    this.providers.forEach(pro => {
      if (pro._id !== element) {
        array.push(pro);
      }
    });
    return array;
  }

  getEmailId(element) {
    return element?.email ? element.email : '';
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  async loadDataForProvider() {
    let res = await this.services.getAllSameCompanyProviders(this.company_id).subscribe(data => {
      this.providers = data;
      this.providers = this.providers.data;
      this.services.getProviderRelations(this.company_id).subscribe(data => {
        this.relationData = data;
        if (this.relationData.status == 200) {
          this.providers.forEach(provider => {
            this.relationData.data.forEach(relation => {
              if (provider?._id == relation?.provider_id?._id) {
                provider.assos_providers = relation.assoc_provider_id;
              }
            });
          });
          this.providers.forEach(pro => {
            let array = []
            if (!Array.isArray(pro.assos_providers)) {
              pro.assos_providers = [];
            }
            this.providers.forEach(innerPro => {
              if (innerPro._id != pro._id) {
                array.push(innerPro)
              }
            });
            pro.dropdown = array;
          });
          this.dataSource = new MatTableDataSource(this.providers);
          this.assigned = true;
        }
      })
    });
  }

  onSelectAllProvider(provider) {
    const details = {
      providerID: provider._id,
      providerIDs: this.providers.map(p => p._id).filter(p => p !== provider._id),
      isRelationCreating: true,
      company_id: provider.company_id
    }
    this.updateRelationWithAllProviders(details);
  }

  onDeSelectAllProvider(provider) {
    const details = {
      providerID: provider._id,
      providerIDs: this.providers.map(p => p._id).filter(p => p !== provider._id),
      isRelationCreating: false,
      company_id: provider.company_id
    }
    this.updateRelationWithAllProviders(details);
  }

  updateRelationWithAllProviders(details) {
    this.services.updateRelationWithAllProviders(details).subscribe((response: any) => {
      if (response.status == 200) {
        // this.loadDataForProvider();
        this.toastr.success("Relationship updated");
      }
    })
  }
  onProviderDeSelect(selectedProvider, provider) {
    const details = {
      providerID: provider._id,
      providerIDs: selectedProvider._id,
      company_id: provider.company_id
    }
    this.deleteRelationProvider2Provider(details);
  }

  showToast() {
    this.toastr.error("Self Association issue")
  }
  onProviderSelect(selectedProvider, provider) {
    if (selectedProvider._id == provider._id) {
      this.toastr.error("Self Association issue")
      return;
    }
    const details = {
      providerID: provider._id,
      providerIDs: selectedProvider._id,
      company_id: provider.company_id
    }
    console.log('details', details);
    this.createRelationProvider2Provider(details);
  }
  createRelationProvider2Provider(details) {
    this.services.createRelationProvider2Provider(details).subscribe((response: any) => {
      if (response.status == 200) {
        // this.loadDataForProvider();
        const providerToInsert = this.providers.find(provider => provider._id === details.providerID)
        this.providers.forEach(element => {
          if (element._id == details.providerIDs) {
            let obj = { _id: providerToInsert._id, full_name: providerToInsert.full_name, first_name: providerToInsert.first_name, last_name: providerToInsert.last_name, email: providerToInsert.email, title: providerToInsert.title };
            element.assos_providers = [...element.assos_providers, obj];
          }
        });
        this.toastr.success("Relationship updated")
      }
    })
  }
  deleteRelationProvider2Provider(details) {
    this.services.deleteRelationProvider2Provider(details).subscribe((response: any) => {
      if (response.status == 200) {
        // this.providers.forEach(element => {
        //   if (element._id == details.providerIDs) {
        //     console.log('idd', element);

        //     element.assos_providers.filter(provider => {
        //       provider._id != details.providerID
        //     })
        //   }
        // });
        // this.loadDataForProvider(); 
        this.toastr.success("Relationship updated")
      }
    })
  }

  getProvidersName(providers) {
    let pro: any = []
    providers?.assos_providers?.forEach(provider => {
      pro.push(provider.name);
    })
    return pro;
  }

}
